import React from "react";
import { MapPin } from "lucide-react";

import { Button } from "../ui/button";
import toastError from "../../errors/toastError";

const LocationPreview = ({ image, link, description }) => {
	const abrirMapa = () => {
		try {
			window.open(link, "_blank", "noopener,noreferrer");
		} catch (err) {
			toastError(err);
		}
	};

	return (
		<div className="w-[250px] overflow-hidden rounded-lg border bg-card">
			<button
				type="button"
				onClick={abrirMapa}
				disabled={!link}
				className="block w-full"
				aria-label="Abrir localização no mapa"
			>
				{image ? (
					<img
						src={image}
						alt="Prévia da localização"
						className="h-[120px] w-full object-cover"
					/>
				) : (
					<div className="flex h-[120px] w-full items-center justify-center bg-muted">
						<MapPin className="h-6 w-6 text-muted-foreground" />
					</div>
				)}
			</button>

			{description && (
				<p className="whitespace-pre-line px-3 py-2 text-xs text-muted-foreground">
					{description.split("\\n").join("\n")}
				</p>
			)}

			<div className="border-t">
				<Button
					variant="ghost"
					className="w-full rounded-none"
					onClick={abrirMapa}
					disabled={!link}
				>
					Visualizar
				</Button>
			</div>
		</div>
	);
};

export default LocationPreview;
